import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { app, tutorial1, tutorial2, tutorial3, tutorial4 } from "./routes";
import { Assessments, General, Reports, Students } from "pages/Tutorials";

const TutorialRoutes = () => {
    return (
        <>
            <Routes>
                <Route exact path={tutorial1} element={
                    <General />
                } />
                <Route exact path={tutorial2} element={
                    <Students />
                } />
                <Route exact path={tutorial3} element={
                    <Assessments />
                } />
                <Route exact path={tutorial4} element={
                    <Reports />
                } />
                <Route exact path={"/*"} element={
                    <Navigate to={app.tutorial1} />
                } />
            </Routes>
        </>
    );
}

export default TutorialRoutes
